import { PUZZLE_SIZE } from '../game/constants'
import { puzzleNumber } from '../game/daily'
import { useLang } from '../i18n/LangContext'

const LETTERS = ['L', 'i', 'n', 'e', 'u', 'p']

export function Landing({
  onPlay,
  onEndless,
}: {
  onPlay: () => void
  onEndless: () => void
}) {
  const { t, lang } = useLang()

  let dateLabel: string
  try {
    dateLabel = new Intl.DateTimeFormat(lang, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(new Date())
  } catch {
    dateLabel = ''
  }

  return (
    <section className="landing">
      <div className="tiles" aria-label="Lineup">
        {LETTERS.map((ch, i) => (
          <span className="tile-letter" key={i} aria-hidden="true">
            {ch}
          </span>
        ))}
      </div>

      <p className="landing-tagline">{t.lede(PUZZLE_SIZE)}</p>

      <div className="landing-actions">
        <button className="btn play-btn" onClick={onPlay}>
          {t.play}
          <span className="btn-arrow" aria-hidden="true">→</span>
        </button>
        <button className="btn ghost endless-btn" onClick={onEndless}>
          {t.endless}
        </button>
      </div>

      <div className="landing-meta">
        {dateLabel && <span className="landing-date">{dateLabel}</span>}
        <span className="landing-puzzle">
          {t.daily} № {puzzleNumber()}
        </span>
      </div>

      <div className="landing-divider" aria-hidden="true" />
    </section>
  )
}
